import { createFileRoute } from '@tanstack/react-router'

import { PlatformMoreScreen } from '@/features/more/platform-more-screen'

/** The console's More on a phone: the switch, then the screens its tabs have no room for. */
export const Route = createFileRoute('/_app/platform/more')({
  component: PlatformMoreScreen,
})
